<powerbi-report [embedConfig]="reportConfig"> </powerbi-report>
